import { StudioActionTypes, All } from '../actions/studio.actions';
import { StudioTemplate, RequestStatus, TextSymbol, Symbol, Icon, Media, PricePointTemplate, Offer, OfferTemplate, DocumentSegment, PageBackground,PageTemplate } from '@app/shared';


// define State interface
export interface State {
  // is a user authenticated?
  mode:string | null;
  actionType:string | null;
  selectedTemplate: StudioTemplate | null;
  errorStatus: RequestStatus | null;
  successStatus: RequestStatus | null;
  // if authenticated, there should be a user object
  textAssets: TextSymbol[] | null;
  symbolAssets: Symbol[] | null;
  iconAssets : Icon[] | null;
  imageAssets : Media[] | null;
  pricepointAssets : PricePointTemplate[] | null;
  offerTemplateAssets : OfferTemplate[] | null;
  symbolTemplateAssets : Symbol[] | null;
  selectedDocumentSegment : DocumentSegment | null;
  pageBackgrounds:PageBackground[] | null;
  pageTemplates:PageTemplate[] | null;
  offerTemplates:OfferTemplate[] | null;
}

// define initial state
export const initialState: State = {
  mode: null,
  actionType:null,
  selectedTemplate: null,
  errorStatus:null,
  successStatus:null,
  textAssets: null,
  symbolAssets:null,
  iconAssets:null,
  imageAssets:null,
  pricepointAssets:null,
  offerTemplateAssets:null,
  symbolTemplateAssets:null,
  selectedDocumentSegment:null,
  pageBackgrounds:null,
  pageTemplates:null,
  offerTemplates:null,
};

export function reducer(state = initialState, action: All): State {
  switch (action.type) {
    case StudioActionTypes.CREATE_STUDIO_TEMPLATE_SUCCESS: {
      return {
        ...state,
        actionType:action.type,
        selectedTemplate: action.payload.studioTemplate,
        mode:action.payload.mode,
      };
    }
    case StudioActionTypes.GET_STUDIO_TEMPLATE_SUCCESS: {
      return {
        ...state,
        actionType:action.type,
        selectedTemplate: action.payload.studioTemplate,
        mode:action.payload.mode,
      };
    }
    case StudioActionTypes.GET_SYMBOLS_SUCCESS: {
      return {
        ...state,
        actionType:action.type,
        symbolAssets: action.payload.symbolAssets,
      };
    }
    case StudioActionTypes.CHECK_FILE_EXISTS_SUCCESS: {
      return {
        ...state,
        actionType:action.type,
      };
    }

    case StudioActionTypes.GET_PRICE_POINT_TEMPLATES_SUCCESS: {
      return {
        ...state,
        actionType:action.type,
        pricepointAssets: action.payload.pricepointAssets,
      };
    }

    // case StudioActionTypes.GET_OFFER_TEMPLATES_SUCCESS: {
    //   console.log('action', action)
    //   return {
    //     ...state,
    //     offerTemplateAssets: action.payload.offerTemplateAssets,
    //   };
    // }

    case StudioActionTypes.GET_SYMBOL_TEMPLATES_SUCCESS: {
      return {
        ...state,
        actionType:action.type,
        symbolTemplateAssets: action.payload.symbolTemplateAssets,
      };
    }

    case StudioActionTypes.EDIT_DOCUMENT_SEGMENT_SUCCESS: {
      return {
        ...state,
        actionType:action.type,
        selectedDocumentSegment: action.payload.documentSegment,
      };
    }
    case StudioActionTypes.GET_PAGE_BACKGROUNDS_SUCCESS: {
      return {
        ...state,
        errorStatus:null,
        actionType:action.type,
        pageBackgrounds:action.payload.pageBackgrounds,
      };
    }
    case StudioActionTypes.GET_PAGE_TEMPLATES_SUCCESS: {
      return {
        ...state,
        errorStatus:null,
        actionType:action.type,
        pageTemplates:action.payload.pageTemplates,
      };
    }
    case StudioActionTypes.GET_OFFER_TEMPLATES_SUCCESS: {
      return {
        ...state,
        errorStatus:null,
        actionType:action.type,
        offerTemplates:action.payload.offerTemplates,
      };
    }
    case StudioActionTypes.CHECK_FILE_EXISTS_FAILURE:
    case StudioActionTypes.ASSIGN_PAGE_TEMPLATE_FAILURE:
    case StudioActionTypes.ASSIGN_OFFER_TEMPLATE_FAILURE:
    case StudioActionTypes.GET_OFFER_TEMPLATES_FAILURE:
    case StudioActionTypes.GET_PAGE_TEMPLATES_FAILURE:
    case StudioActionTypes.GET_PAGE_BACKGROUNDS_FAILURE: {
      return {
        ...state,
        errorStatus: action.payload.errorStatus,
        actionType:action.type,
        successStatus:null,
      };
    }
    default: {
      return {
        ...state,
        errorStatus: null,
        actionType:null,
        successStatus:null,
      };
    }
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/pmclient-uat/src/app/store/reducers/studio.reducer.ts